// removed by extract-text-webpack-plugin
module.exports = {"gwTileContentInside":"tile-content-hashed__gwTileContentInside__2ofnp","gwTileContentItem":"tile-content-hashed__gwTileContentItem__2I-WV"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tiles/tileLayout/Content/tile-content-hashed.scss
// module id = 1221
// module chunks = 0